/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_PermisoRequerido as PermisoRequerido,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_li as li,
  rec_obtenerToken as obtenerToken,
  rec_st as st,
  rec_wo as wo,
} from "../../runtime/index.jsx";
export function PaginaNoEncontrada() {
  let e = (0, ReactCompiler.c)(3),
    t = st(),
    n;
  e[0] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((n = obtenerToken() ? (wo() ?? `/`) : `/login`), (e[0] = n))
    : (n = e[0]);
  let r = n,
    i;
  return (
    e[1] === t
      ? (i = e[2])
      : ((i = (
          <PermisoRequerido
            icono={li}
            codigo={`404`}
            titulo={`Esta página no existe`}
            mensaje={`El enlace puede estar mal escrito o la página ya no está.`}
            acciones={[
              {
                texto: `Ir al inicio`,
                principal: !0,
                alHacer: () =>
                  t(r, {
                    replace: !0,
                  }),
              },
            ]}
          />
        )),
        (e[1] = t),
        (e[2] = i)),
    i
  );
}
